import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { getStudentBookedTutorDetailData } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';
import toast from 'react-hot-toast';
import { jwtDecode } from 'jwt-decode';
import moment from "moment-timezone";


const getTimezone = (abb) => {
  const map = {
    PDT: "America/Los_Angeles",
    PST: "America/Los_Angeles",
    MDT: "America/Denver",
    MST: "America/Denver",
    CDT: "America/Chicago",
    CST: "America/Chicago",
    EDT: "America/New_York",
    EST: "America/New_York",
    CET: "Europe/Paris",
    CEST: "Europe/Paris",
    BST: "Europe/London",
    GMT: "Etc/GMT",
    JST: "Asia/Tokyo",
    KST: "Asia/Seoul",
    HKT: "Asia/Hong_Kong",
    SGT: "Asia/Singapore",
    MYT: "Asia/Kuala_Lumpur",
    ICT: "Asia/Bangkok",
    PKT: "Asia/Karachi",
    GST: "Asia/Dubai",
    AST: "Asia/Riyadh",
    AEST: "Australia/Sydney",
    AEDT: "Australia/Sydney",
    ACST: "Australia/Adelaide",
    AWST: "Australia/Perth",
    EAT: "Africa/Nairobi",
    CAT: "Africa/Harare",
    WAT: "Africa/Lagos",
    BRT: "America/Sao_Paulo",
    ART: "America/Argentina/Buenos_Aires",
    NZST: "Pacific/Auckland",
    NZDT: "Pacific/Auckland"
  };

  return map[abb] || moment.tz.guess();
};

const host = process.env.REACT_APP_API_SERVER
const StudentOneToOneCourseDetails = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { b64id } = useParams();
    const authToken = localStorage.getItem('student-token');
    const decoded = jwtDecode(authToken);

    const userTimeZone = decoded?.user?.time_zone

    const currentDate = moment().tz(userTimeZone).toDate();

    useEffect(() => {
        try {

            const requestId = atob(b64id);


            if (!requestId || isNaN(requestId)) {
                throw new Error("Invalid course ID");
            }


            dispatch(getStudentBookedTutorDetailData(requestId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);



    const {
        loadingStudentBookedTutorDetailApi,
        StudentBookedTutorDetailApiData,
        StudentBookedTutorDetailApiError
    } = useSelector(state => state?.StudentReducer);


    // const handleJoinMeeting = (start_date, start_timeee, start_time, end_time, link, meeting_provider) => {


    //     const sessionStartDateTime = new Date(start_time);

    //     const sessionEndDateTime = new Date(end_time);

    //     const currentDateTime = new Date();

    //     // Determine meeting status
    //     if (currentDateTime < sessionStartDateTime) {
    //         toast.success(
    //             <div>Meeting starts on {start_date} {start_timeee}</div>
    //         );
    //     } else if (currentDateTime > sessionEndDateTime) {
    //         toast.error(
    //             <div>Meeting link expired</div>
    //         );
    //     } else {
    //         // Allow joining if within valid time window
    //         if (meeting_provider == 'gmeet') {
    //             window.open(link, '_blank', 'noopener,noreferrer');

    //         }
    //         else {
    //             navigate(`/show-meeting`, {
    //                 state: {
    //                     authToken: localStorage.getItem('student-token'),
    //                     meetingLink: link,
    //                     end_time: end_time,
    //                     tutor_id: StudentBookedTutorDetailApiData?.tutor_id,
    //                     student_id: StudentBookedTutorDetailApiData?.student_id,
    //                     session_id: StudentBookedTutorDetailApiData?.course?.id,
    //                     booked_id: StudentBookedTutorDetailApiData?.order_id
    //                 },
    //             });
    //         }
    //     }
    // };


    const handleJoinMeeting = (
  start_date,
  start_timeee,
  start_time,
  end_time,
  link,
  meeting_provider,
  timeZoneAbb
) => {

  const timezone = getTimezone(timeZoneAbb);

  const sessionStart = moment.tz(start_time, timezone).valueOf();
  const sessionEnd = moment.tz(end_time, timezone).valueOf();
  const currentTime = moment().valueOf();

  const joinBefore = moment(sessionStart).subtract(5, "minutes").valueOf();

  if (currentTime < joinBefore) {

    toast.success(
      <div>Meeting starts on {start_date} {start_timeee}</div>
    );

  } else if (currentTime > sessionEnd) {

    toast.error(<div>Meeting link expired</div>);

  } else {

    if (meeting_provider === "gmeet") {

      window.open(link, "_blank", "noopener,noreferrer");

    } else {

      navigate(`/show-meeting`, {
        state: {
          authToken: localStorage.getItem("student-token"),
          meetingLink: link,
          end_time: sessionEnd,
          tutor_id: StudentBookedTutorDetailApiData?.tutor_id,
          student_id: StudentBookedTutorDetailApiData?.student_id,
          session_id: StudentBookedTutorDetailApiData?.course?.id,
          booked_id: StudentBookedTutorDetailApiData?.order_id
        }
      });

    }
  }
};


    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;View Details
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingStudentBookedTutorDetailApi ?
                                    <Beatloader />
                                    :
                                    <div className="my-schedule-detail-sec">
                                        <div className="row align-items-baseline">
                                            <div className="col-lg-2">
                                                <img
                                                    src={`${host}${StudentBookedTutorDetailApiData?.tutor?.profile_img}`}
                                                    className="img-fluid w-auto"
                                                    style={{ borderRadius: 15 }}
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-7">
                                                <h4 className="mb-0">{StudentBookedTutorDetailApiData?.tutor?.name}</h4>
                                                <p className="mb-0 text-primary fw-bold">{StudentBookedTutorDetailApiData?.tutor?.tutordetails?.specialization}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0 mt-2 fw-bold">
                                                    <i className="fa-solid fa-calendar-days" /> Scheduled Date
                                                </p>
                                                <p className="mb-0 ms-4 text-primary fw-bold"> {StudentBookedTutorDetailApiData?.course?.start_date}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-4 mb-3">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Class/Grade/General</p>
                                                <p className="mb-0 fw-bold">{StudentBookedTutorDetailApiData?.course?.category?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Subject</p>
                                                <p className="mb-0 fw-bold">{StudentBookedTutorDetailApiData?.course?.subcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Module</p>
                                                <p className="mb-0 fw-bold">{StudentBookedTutorDetailApiData?.course?.childcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Course Name</p>
                                                <p className="mb-0 fw-bold">{StudentBookedTutorDetailApiData?.course?.name}</p>
                                            </div>
                                        </div>
                                        {/*  */}
                                        <div className="row mb-4">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Session Start date</p>
                                                <p className="mb-0 fw-bold text-primary">{StudentBookedTutorDetailApiData?.course?.start_date}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Session End date</p>
                                                <p className="mb-0 fw-bold text-primary">{StudentBookedTutorDetailApiData?.course?.end_date}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-5">
                                            {StudentBookedTutorDetailApiData?.course?.courseSession?.map((data) => (

                                                <div className="col-lg-4 my-2">
                                                    <div className="card bg-light" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                        <div className="card-body d-flex flex-column">
                                                            <div className='d-flex justify-content-between'>
                                                                <h6>Start Date: {data?.formated_start_date} </h6>
                                                                <Link
                                                                    to={`/student/recordings/${btoa(StudentBookedTutorDetailApiData?.course?.meetting_link)}`}
                                                                    state={{ course: StudentBookedTutorDetailApiData?.course?.name }}
                                                                >
                                                                    <i className='fa fa-download'></i>
                                                                </Link>
                                                            </div>

                                                            <h6>
                                                                Time Slot: {data?.timeslots?.formated_start_time} - {data?.timeslots?.formated_end_time} ({data?.timeslots?.timeZoneAbb})
                                                            </h6>
                                                            <h6>Topic Details: {data?.topic_details}</h6>

                                                            <div className="mt-auto">
                                                                {/* {new Date(data?.timeslots?.new_end_date_time) >= currentDate && ( */}
                                                                {moment.tz(
  data?.timeslots?.new_end_date_time,
  getTimezone(data?.timeslots?.timeZoneAbb)
).isAfter(moment().tz(getTimezone(data?.timeslots?.timeZoneAbb))) && (
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        onClick={() => 
                                                                        //     handleJoinMeeting(
                                                                        //     data?.formated_start_date,
                                                                        //     data?.timeslots?.formated_start_time,
                                                                        //     data?.timeslots?.new_start_date_time,
                                                                        //     data?.timeslots?.new_end_date_time,
                                                                        //     StudentBookedTutorDetailApiData?.course?.meetting_link,
                                                                        //     StudentBookedTutorDetailApiData?.course?.meeting_provider
                                                                        // )
                                                                       handleJoinMeeting(
  data?.formated_start_date,
  data?.timeslots?.formated_start_time,
  data?.timeslots?.new_start_date_time,
  data?.timeslots?.new_end_date_time,
  StudentBookedTutorDetailApiData?.course?.meetting_link,
  StudentBookedTutorDetailApiData?.course?.meeting_provider,
  data?.timeslots?.timeZoneAbb
)    
                                                                    }
                                                                    >
                                                                        Join Meeting
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>


                                            ))}
                                        </div>
                                    </div>
                                }
                            </main>


                        </div>
                    </div>
                </div>
            </section>



        </div>
    )
}

export default StudentOneToOneCourseDetails